import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Sparkles } from "lucide-react";
import Header from "@/components/landing/Header";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MissionVisionValues() {
  const [legal, setLegal] = useState(null);
  useEffect(() => {
    axios.get(`${API}/legal`).then((r) => setLegal(r.data)).catch(() => {});
  }, []);
  if (!legal) return <main className="bg-cream min-h-screen"><Header /><p className="text-center pt-40 text-ink-mid">Cargando…</p></main>;
  return (
    <main className="bg-cream text-ink min-h-screen">
      <Header />
      <div className="max-w-5xl mx-auto px-6 md:px-12 pt-32 md:pt-40 pb-20">
        <Link to="/" data-testid="mvv-back" className="inline-flex items-center gap-1 text-xs text-ink-mid hover:text-coral mb-6">
          <ArrowLeft className="w-3.5 h-3.5" /> Volver al inicio
        </Link>
        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral mb-2 inline-flex items-center gap-1.5">
          <Sparkles className="w-3 h-3" /> Misión · Visión · Valores
        </p>
        <h1 data-testid="mvv-title" className="font-serif text-5xl md:text-7xl tracking-tighter leading-[0.95] mb-12">
          Por qué <span className="italic text-coral">existimos</span>.
        </h1>

        <section data-testid="mvv-mission" className="grid md:grid-cols-12 gap-6 mb-14 pb-14 border-b hairline">
          <p className="md:col-span-3 font-mono text-[11px] uppercase tracking-[0.3em] text-ink-mid pt-2">Misión</p>
          <p className="md:col-span-9 font-serif text-2xl md:text-3xl leading-[1.25] tracking-tight">
            {legal.mission}
          </p>
        </section>

        <section data-testid="mvv-vision" className="grid md:grid-cols-12 gap-6 mb-14 pb-14 border-b hairline">
          <p className="md:col-span-3 font-mono text-[11px] uppercase tracking-[0.3em] text-ink-mid pt-2">Visión</p>
          <p className="md:col-span-9 font-serif text-2xl md:text-3xl leading-[1.25] tracking-tight">
            {legal.vision}
          </p>
        </section>

        <section data-testid="mvv-values">
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-ink-mid mb-6">Valores</p>
          <div className="grid md:grid-cols-2 gap-4">
            {(legal.values || []).map((v, i) => (
              <article key={i} data-testid={`mvv-value-${i}`} className="border hairline bg-cream-card rounded-2xl p-6">
                <p className="font-mono text-[10px] uppercase tracking-wider text-coral mb-2">0{i + 1}</p>
                <h3 className="font-serif text-2xl tracking-tight mb-2">{v.title}</h3>
                <p className="text-sm text-ink-mid leading-relaxed">{v.desc}</p>
              </article>
            ))}
          </div>
        </section>

        {legal.company && (
          <section className="mt-16 pt-10 border-t hairline">
            <p className="font-mono text-[10px] uppercase tracking-wider text-ink-mid mb-2">◊ Quiénes somos</p>
            <p className="text-sm text-ink-mid">
              <strong>{legal.company.legal_name}</strong> · {legal.company.country}
            </p>
            <p className="text-xs text-ink-mid mt-1">
              Contacto · <a href={`mailto:${legal.company.contact_email}`} className="text-coral hover:underline">{legal.company.contact_email}</a> ·
              Soporte · <a href={`mailto:${legal.company.support_email}`} className="text-coral hover:underline ml-1">{legal.company.support_email}</a>
            </p>
          </section>
        )}
      </div>
    </main>
  );
}
